import { isObjectEmpty } from "@crema/utility/Utils";
import {
    CREATE_AREA,
    CREATE_FEEDBACK,
    DELETE_AREA,
    DELLETE_FEEDBACK,
    FEED_BACK_DETAILS,
    FEED_BACK_QRCODE,
    GET_AREA,
    GET_FEEDBACK,
    GET_USERS_FEEDBACK_RESPONSES,
    UPDATE_AREA,
    UPDATE_FEEDBACK,
} from "shared/constants/ActionTypes";

const initialState = {
    error: null,
    areaMasterList: [],
    feedBackList: [],
    userFeedBackResponses: [],
    feedBackAreaDetails: {},
    qrCodeQuestion: [],
};

const addFeedbackAreaDetails = (previousState, payload) => {
    if (!isObjectEmpty(previousState)) {
        const previousData = { ...previousState };
        previousData.data = [...previousData.data, payload];
        return previousData;
    }
};
const updateFeedbackAreaDetails = (previousState, payload) => {
    if (!isObjectEmpty(previousState)) {
        return {
            ...previousState,
            data: [
                ...previousState.data.map((item) => {
                    return item.id === payload.id ? payload : item;
                }),
            ],
        };
    }
};

export const areaMasterReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_AREA:
            return {
                ...state,
                areaMasterList: payload,
            };
        case CREATE_AREA:
            return {
                ...state,
                areaMasterList: [payload, ...state.areaMasterList],
            };
        case UPDATE_AREA:
            return {
                ...state,
                areaMasterList: [
                    ...state.areaMasterList.map((item) =>
                        item.id === payload.id ? { ...payload.data } : item
                    ),
                ],
            };
        case DELETE_AREA:
            return {
                ...state,
                areaMasterList: state.areaMasterList.filter(
                    (el) => el.id !== payload.id
                ),
            };
        case GET_FEEDBACK:
            return { ...state, feedBackList: payload };
        case GET_USERS_FEEDBACK_RESPONSES:
            return { ...state, userFeedBackResponses: payload };
        case CREATE_FEEDBACK:
            return {
                ...state,
                feedBackList: [payload, ...state.feedBackList],
                feedBackAreaDetails: addFeedbackAreaDetails(
                    state.feedBackAreaDetails,
                    payload
                ),
            };
        case DELLETE_FEEDBACK:
            return {
                ...state,
                feedBackList: state.feedBackList.filter(
                    (el) => el.id !== payload.id
                ),
                feedBackAreaDetails: {
                    ...state.feedBackAreaDetails,
                    data: state.feedBackAreaDetails?.data?.filter(
                        (el) => el.id !== payload.id
                    ),
                },
            };
        case UPDATE_FEEDBACK:
            return {
                ...state,
                feedBackList: [
                    ...state.feedBackList.map((item) =>
                        item.id == payload.id ? { ...payload } : item
                    ),
                ],
                feedBackAreaDetails: updateFeedbackAreaDetails(
                    state.feedBackAreaDetails,
                    payload
                ),
            };
        case FEED_BACK_DETAILS:
            return {
                ...state,
                feedBackAreaDetails: payload,
            };
        case FEED_BACK_QRCODE:
            return { ...state, qrCodeQuestion: payload };
        default:
            return state;
    }
};
